import React from 'react'
import { SimpleBox as OriginalSimpleBox } from '@next-nx/shared-ui/organisms'
import { SimpleBoxSettings } from './SimpleBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  ctaLabel: 'Cta',
  link: '',
  pageLink: '',
  openNewTab: false,
}

export const SimpleBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { 
      ctaLabel,
      link,
      pageLink,
      openNewTab,
    } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-simple-box ' + props.className}
      >
        <OriginalSimpleBox
          item={{
            name: children.props.children[0],
            description: children.props.children[1],
            ctaLabel: ctaLabel,
            url: pageLink || link || '#',
            blank: openNewTab
          }}
          editMode={enabled}
        />
      </div>
    );
  },
  defaultProps
);

SimpleBox.craft = withCraft({
  name: 'SimpleBox',
  defaultProps: defaultProps,
  settings: SimpleBoxSettings,
});
